module.exports = __webpack_public_path__ + "img/polisorb_logo.ccc8523a.svg";